import { ResonanceUpdatedBy } from "../../entityComposites";
import { ResonanceDates } from "../../global";
import {
    VariantShippingDimensionUnit,
    VariantWeightUnit,
} from "../common/VariantCommon";

import { DemandHqId, OrderId, OrderItemId, OrderReturnId } from "./DemandIds";

export enum OrderReturnStatus {
    Requested = "REQUESTED",
    Approved = "APPROVED",
    ApprovedSynced = "APPROVED_SYNCED",
    Declined = "DECLINED",
    Rejected = "REJECTED",
    RefundApproved = "REFUND_APPROVED",
    Refunded = "REFUNDED",
}

export enum OrderReturnReason {
    Defective = "DEFECTIVE",
    WrongItem = "WRONG_ITEM",
    NotAsDescribed = "NOT_AS_DESCRIBED",
    NoLongerNeeded = "NO_LONGER_NEEDED",
    SizeFit = "SIZE_FIT",
    Damaged = "DAMAGED",
    Other = "OTHER",
}

export interface OrderReturnLineItem {
    orderItemId: OrderItemId;
    fulfillmentLineItemId?: string | null;
    quantity: number;
    returnReason: OrderReturnReason;
    returnReasonNote?: string | null;
    sku?: string | null;
}

export interface OrderReturnImageReference {
    s3Key: string;
    fileName?: string | null;
}

export interface OrderReturnIdFields {
    orderReturnId: OrderReturnId;
}

export interface OrderReturnRelationshipFields {
    demandHqId: DemandHqId;
    orderId: OrderId;
}

export interface OrderReturnShippingWeight {
    amount: number;
    unit: VariantWeightUnit;
}

export interface OrderReturnShippingDimensions {
    length: number;
    width: number;
    height: number;
    unit: VariantShippingDimensionUnit;
}

export interface OrderReturnDataFields {
    status: OrderReturnStatus;
    returnLineItems: OrderReturnLineItem[];
    imageReferences?: OrderReturnImageReference[] | null;
    shippingWeight?: OrderReturnShippingWeight | null;
    shippingDimensions?: OrderReturnShippingDimensions | null;
    shopifyReturnId?: string | null;
    sellerCloudRmaId?: string | null;
    trackingNumber?: string | null;
    customerNote?: string | null;
    csNote?: string | null;
    requestedAt?: string | null;
    approvedAt?: string | null;
    refundedAt?: string | null;
}

export interface OrderReturn
    extends
        OrderReturnDataFields,
        OrderReturnIdFields,
        OrderReturnRelationshipFields,
        ResonanceDates,
        ResonanceUpdatedBy {}

export type OrderReturnModelCreateInput = Omit<
    OrderReturn,
    keyof OrderReturnIdFields | keyof ResonanceDates | keyof ResonanceUpdatedBy
>;

export type OrderReturnApiCreateInput = OrderReturnModelCreateInput;

export type OrderReturnModelUpdateInput = Partial<OrderReturnDataFields> & {
    orderReturnId: OrderReturnId;
};

export type OrderReturnApiUpdateInput = OrderReturnModelUpdateInput;
